import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PostStatusIndicatorComponent } from '../post-status-indicator/post-status-indicator.component';
import { RouterLink } from '@angular/router';
import { Attachment, MediaType, Doddle, Workspace } from '@doddly/core';
import { IconComponent } from '../icon/icon.component';
import { ChannelTypeIconComponent } from '../channel-type-icon/channel-type-icon.component';

@Component({
  selector: 'ly-post',
  standalone: true,
  imports: [
    CommonModule,
    PostStatusIndicatorComponent,
    RouterLink,
    IconComponent,
    ChannelTypeIconComponent,
  ],
  templateUrl: './post.component.html',
  styleUrl: './post.component.scss',
})
export class PostComponent {
  readonly MEDIA_TYPE = MediaType;

  @Input()
  doddle!: Doddle;

  @Input()
  mode: 'list' | 'compact' = 'compact';

  @Input()
  workspace: Workspace | undefined;

  get firstMediaItem(): Attachment | undefined {
    return this.doddle?.mediaItems?.[0];
  }
}
